import { LitElement, html, css } from "lit-element";
import iro from '@jaames/iro';

class ColorPicker extends LitElement {
    
	static get styles(){
		return [css`
            :host{
                display: block;               
            }

            .colors{
                display: flex;
                flex-wrap: wrap;
                margin-left: 15px;
                width: 60px;
            }
            .colors>div{
                border-radius: 50%;
                margin: 3px;
                width: 23px;
                height: 23px;
                cursor: pointer;
            }

            .c0{background-color: #ff0000;}
			.c1{background-color: #00ff00;}
			.c2{background-color: #ffff00;}
			.c3{background-color: #0000ff;}
			.c4{background-color: #f58231;}
			.c5{background-color: #911eb4;}
			.c6{background-color: #00fefe;}
			.c7{background-color: #ff00ff;}
			.c8{background-color: #bfef45;}
			.c9{background-color: #fabebe;}
			.c10{background-color:#9A6324;}
			.c11{background-color:#aaffc3;}
			.c12{background-color:#808000;}
			.c13{background-color:#a9a9a9;}
			.c14{background-color:#ffffff;}
			.c15{background-color:#202020;}
          
            .pad{
                margin-top: 10px;
            }
            .preview{
              
                width: 100px;
                border-radius: 12px;
                height: 25px;                
            }

         

            .btn{
                border:1px solid gray;
                cursor: pointer;
            }

            .wrap{
                display: flex;
                
            }
        `];
	}

	render() {		
		return html`
            <div class="preview btn"  style="background-color: ${this.value}" @click="${()=>this.openDial() }"></div>
            <inspx-dialog id="dial" cancellable .opened="${false}">
                <div class="wrap">
                    <div id="cp"></div>

                    <div class="colors">${this.colors.map((c,i)=> html`<div class='c${i}' @click="${()=> this.selectColor(c)}"></div>`)}</div>
                </div>
                <div class="pad">Selected color</div>
                <div class="preview" style="background-color: ${this.value}"></div>
            </inspx-dialog>
        `;
	}
    
	openDial(){
		this.dialog.open();
	}
	
    
	firstUpdated(){
		let d = this.shadowRoot.getElementById('cp'); 		
		let cp = new iro.ColorPicker(d, { width: 200 });
		cp.on('color:change', (c)=> this.selectColor(c.hexString));
        
		this.dialog= this.shadowRoot.getElementById('dial');
		this.dialog.headerLabel = "Select color";
	
		this.dialog.addEventListener('dialog-accept', (e) => {
			this.dispatchEvent(new CustomEvent('change', { detail: this.value } ));
			this.dialog.close();
		});
		this.dialog.addEventListener('dialog-cancel', (e) => {
			this.dialog.close();
		});
	}
    
	selectColor(c){
		this.value = c;
	}
    
	confirm(){
        
	}

	constructor() {
		super();
		//	this.container = document.createElement("div");
		this.colors = [
			"#ff0000",
			"#00ff00",
			"#ffff00",
			"#0000ff",
			"#f58231",
			"#911eb4",
			"#00fefe",
			"#ff00ff",
			"#bfef45",
			"#fabebe",
			"#9A6324",
			"#aaffc3",
			"#808000",
			"#a9a9a9",
			"#ffffff",
			"#202020"
		];
            
	}

	static get properties() {
		return { value: { type: String } };
	}
}

window.customElements.define("color-picker", ColorPicker);
